if (!customElements.get('vbb-variant-selector')) {
  customElements.define('vbb-variant-selector', class VariantSelector extends HTMLElement {
    constructor() {
      super();
      this.productHandle = this.dataset.productHandle;
      this.activeVariantId = this.dataset.activeVariantId;
      this.activeVariantPrice = this.dataset.variantPrice
      this.card = this.closest('.card');
      this.productForm = document.getElementById(this.dataset.productFormId);
      this.sharpenerCheckbox = this.querySelector('.vbb-variant-selector__sharpener-option');
      this.shouldUpdateProductDetails = this.dataset.updateProductDetails === 'true';
      this.shouldUpdateHistoryState = this.dataset.updateHistoryState === 'true';
      this.isInProductCard = this.dataset.inProductCard === 'true';
      this.variantSelectorItems = this.querySelectorAll('.vbb-variant-selector__item a');
      this.cardTitle = this.querySelector('label')

      if (this.card) {
        this.originalImages = this.card.querySelectorAll('.card__media img');
        this.originalImageSrc = this.originalImages[0].src
        this.originalImageSrcs = Array.from(this.originalImages).map(img => img.srcset);
        this.originalPriceElement = this.card.querySelector('.price-item');
      }
      if(this.dataset.groupSelector === "true"){
        this.activeVariantTitle = this.querySelector('li[data-active="true"]').dataset.variantTitle;
        this.activeVariantDescription= this.querySelector('li[data-active="true"]').dataset.variantDescription;
        this.activeCategory = this.dataset.activeCategory;
      }

      if(!this.card) {
       this.activeVariantLabel = this.querySelector(".js-variant-label");
      }

      this.subscriptionWidget = this.productForm.querySelector('subscriptions-widget');
      this.signupButton = this.productForm.querySelector('.sign-up-button');
      this.atcButton = this.productForm.querySelector('.atc-button');
    }

    get activeVariantContent() {
      return document.querySelector(`#vbb-variant-details-${this.activeVariantId}`).content;
    }

    getTrackingData(event){
      let activeVariantTemplate = JSON.parse(document.querySelector(`#vbb-variant-details-${this.card.querySelector('vbb-product-form').dataset.activeVariant}`)?.content.querySelector('#tracking-info').innerText) ?? null

      if (activeVariantTemplate) {
        const cards = Array.from(document.querySelectorAll('.vbb-collection-grid .card-wrapper'));

        window.Shopify.analytics.publish(`custom_${event}`, {
          event,
          ecommerce: {
            items: [{
              item_id: activeVariantTemplate.item_id,
              item_name: activeVariantTemplate.item_name,
              affiliation: 'Victoria Beckham Beauty',
              currency: activeVariantTemplate.currency,
              index: cards.indexOf(this.closest('.card-wrapper')),
              item_brand: 'Victoria Beckham Beauty',
              ...(activeVariantTemplate.item_variant != null && {
                  item_variant: activeVariantTemplate.item_variant,
                }),
              price: parseFloat(activeVariantTemplate.price),
              quantity: 1
            }]
          }
        });
      }
    }
    handleVariantChange(event, fromSharpener = false) {
      this.updateActiveVariantId(event);
      this.updateProductForm();
      if (this.card) {
        this.replaceMainImage(true);
        this.updateMainUrl(event, this.card);
        this.changeCardPrice(event);
        this.getTrackingData('view_item_list');
      }

      if (event.type === 'click' && this.shouldUpdateHistoryState) {
        this.updateHistoryState();
      }

      this.updateVariantSelector(fromSharpener);
      this.updateSharpenerCheckbox(fromSharpener);
      this.updateWaitlistButton();
      this.updateSpecialLabel();

      if(this.activeVariantLabel) {
        this.updateActiveVariantLabel()
      }

      if (this.shouldUpdateProductDetails) {
        if (!fromSharpener) {
          this.updateCarousel();
          this.updateDescription();
          this.updateIngredientTechnology();
        }

        this.updatePrice();
      }
      if (this.dataset.groupSelector === 'true') {
        // TODO: Fix JS error when toggling with/without sharpener checkbox
        const activeSwatch = event.target.closest('li');
        this.activeCategory = activeSwatch.dataset.category;
        this.activeVariantTitle = `${activeSwatch.dataset.variantTitle} ${activeSwatch.dataset.variantDescription ? ` - ${activeSwatch.dataset.variantDescription}` : ''}`
      }

      console.log('sub widget before', this.subscriptionWidget)

      // Selling plans reset
      if(this.subscriptionWidget) {
        this.subscriptionWidget.setActiveSellingPlan(this.activeVariantId)
      }
    }

    changeCardPrice(event) {
      this.originalPriceElement.innerHTML = event.currentTarget.dataset.variantPrice;
    }

    replaceMainImage(replaceMain) {
      let images = this.card.querySelectorAll('.card__media img');
      images.forEach((img, index) => {
        if (replaceMain) this.originalImageSrcs = [img.srcset]
        img.src = this.originalImageSrc
        img.srcset = this.originalImageSrcs[index];
      });

    }

    handleItemHover(event) {
      const variantId = event.currentTarget.dataset.variantId
      const content = document.querySelector(`#vbb-variant-details-${variantId}`).content;
      let title = content.querySelector('#title').innerHTML;
      if (content.querySelector('#category').innerText !== '') {
        title += ` / ${content.querySelector('#category').innerText}`;
      }
      this.cardTitle.innerText = title
      let newImagesSrc = event.currentTarget.dataset.mainImage

      let image = this.card.querySelector('.card__media img');
      clearTimeout(this.hoverOutTimeout);
      if (newImagesSrc) {
        image.srcset = newImagesSrc;
      }
    }

    handleItemHoverOut(event) {
      this.hoverOutTimeout = setTimeout(() => {
        let activeTitle = document.querySelector(`#vbb-variant-details-${this.productForm.dataset.activeVariant}`).content.querySelector('#title').innerHTML;
        if (this.activeVariantContent.querySelector('#category').innerText !== '') {
          activeTitle += ` / ${this.activeVariantContent.querySelector('#category').innerText}`;
        }
        this.cardTitle.innerText = activeTitle
        this.replaceMainImage(false)
      }, 250);

    }

    updateMainUrl(event, cardElement) {
      const mainLinks = cardElement.querySelectorAll('.card__heading a');
      mainLinks.forEach(link => {
        link.setAttribute('href', event.currentTarget.href);
      });
    }

    updateActiveVariantId(event) {
      if ((event.type === 'popstate') && (event.state?.variantId != null)) {
        this.activeVariantId = event.state.variantId;
      } else if (event.target !== window) {
        if (event?.target?.closest('li')?.dataset?.variantId != null) {
          this.activeVariantId = event.target.closest('li').dataset.variantId;
          this.activeVariantPrice = event.target.closest('li').dataset.variantPrice
        } else if (event?.target?.closest('.vbb-variant-selector__sharpener-option')) {
          this.activeVariantId = this.sharpenerCheckbox.dataset.oppositeVariantId;
        }
      }
    }

    updateHistoryState() {
      const state = {variantId: this.activeVariantId};
      let url = `/products/${this.productHandle}?variant=${this.activeVariantId}`;
      if (this.dataset.market !== '/' && this.dataset.market !== '/fr') {
        url = `${this.dataset.market}${url}`;
      }
      window.history.replaceState(state, null, url);
    }

    updateVariantSelector(fromSharpener) {
      this.querySelectorAll('li').forEach(item => {
        if (fromSharpener) {
          const currentId = item.dataset.variantId;
          const oppositeId = this.mappedSharpenerVariantIds[currentId];

          item.dataset.variantId = oppositeId;
          item.dataset.oppositeVariantId = currentId;

          item.querySelector('a').setAttribute('href', item.querySelector('a').getAttribute('href').replace(currentId, oppositeId));
          item.dataset.isWaitlisted = this.activeVariantContent.querySelector('#is-waitlisted').innerText === 'true';
        }

        if (this.sharpenerCheckbox) {
          this.sharpenerCheckbox.dataset.variantId = this.activeVariantId;
          this.sharpenerCheckbox.dataset.oppositeVariantId = this.mappedSharpenerVariantIds[this.activeVariantId];
        }

        item.dataset.active = (item.dataset.variantId === this.activeVariantId);
      });

      if (this.isInProductCard && this.querySelector('.vbb-variant-selector > label')) {
        let label = this.activeVariantContent.querySelector('#title').innerText;

        if (this.activeVariantContent.querySelector('#category').innerText !== '') {
          label += ` / ${this.activeVariantContent.querySelector('#category').innerText}`;
        }

        this.querySelector('.vbb-variant-selector > label').innerText = label;
      }
    }

    updateSharpenerCheckbox(fromSharpener) {
      if (fromSharpener) {
        this.sharpenerCheckbox.querySelector('input').checked = !this.sharpenerCheckbox.querySelector('input').checked;

        const currentId = this.activeVariantId;
        const oppositeId = this.mappedSharpenerVariantIds[currentId];

        this.sharpenerCheckbox.dataset.variantId = currentId;
        this.sharpenerCheckbox.dataset.oppositeVariantId = oppositeId;

        this.sharpenerCheckbox.querySelector('a').setAttribute(
          'href',
          this.sharpenerCheckbox.querySelector('a').getAttribute('href').replace(oppositeId, currentId)
        );
      }
    }

    updateSpecialLabel() {
      const newLabel = this.activeVariantContent.querySelector('#special-label')?.innerText.trim() ?? '';
      if(this.isInProductCard){
        this.card.querySelector('.vbb-special-label').innerText = newLabel
      }
      else {
        const existingSpecialLabel = document.querySelectorAll('.vbb-product-details__buybox .vbb-special-label');
        existingSpecialLabel.forEach(item => item.innerText = newLabel)
      }
    }

    updatePrice() {
     const buyboxPrices = document.querySelectorAll('.vbb-product-details__buybox__details__price')
     buyboxPrices.forEach(e => e.innerText = this.activeVariantContent.querySelector('#price').innerText.trim())
    }

    // This will be updated in the future to be the event fired from the carousel. This will stand as a POC for now.
    updateCarousel() {
      const event = new CustomEvent('updateCarousel', {
        detail: { variant: this.activeVariantId }
      });
      this.dispatchEvent(event);
    }

    updateActiveVariantLabel() {
      if(!this.card){
        const swatchDescription = this.activeVariantContent.querySelector('#swatch-description').innerText.trim() ?? ''
        const swatchLabel = this.activeVariantContent.querySelector('#title').innerText.trim() ?? ''
        if(!this.activeVariantLabel) return;
        this.activeVariantLabel.innerText = `${swatchLabel} ${swatchDescription ? ` - ${swatchDescription}` : ''}`
      }
    }
    updateDescription() {
      const newDescription = this.activeVariantContent.querySelector('#description');
      const tabDescription = document.querySelector('.vbb-product-tabs__description__variant');
      if (newDescription?.childNodes?.length > 0 && tabDescription) {
        tabDescription.innerHTML = newDescription.innerHTML;
      }
    }

    updateIngredientTechnology() {
      const productTitle = document.querySelector('.vbb-product-details__buybox h1').innerText.trim();
      const newVariantTitle = this.activeVariantContent.querySelector('#title').innerText.trim();
      const newIngredientTechnology = this.activeVariantContent.querySelector('#ingredient-technology').innerHTML;

      const existingIngredientTechnologyTitle = document.querySelector('#ingredient-technology-title');
      const existingIngredientTechnologyContent = document.querySelector('#ingredient-technology-content');

      if (existingIngredientTechnologyTitle) {
        existingIngredientTechnologyTitle.innerText = `Ingredients List - ${productTitle} in ${newVariantTitle}`;
      }

      if (existingIngredientTechnologyContent && newIngredientTechnology !== '') {
        existingIngredientTechnologyContent.innerHTML = newIngredientTechnology;
      }
    }

    updateProductForm() {
      this.productForm.dataset.activeVariant = this.activeVariantId;
      this.productForm.dataset.variantPrice = this.activeVariantPrice;
      this.productForm.dataset.maxQuantity = this.activeVariantContent.querySelector('#limit-per-order').innerText;
      this.productForm.hideError();
    }

    handleSignupClick(signupID, signupIDMobile) {
      if (!window.__attentive) return;

      if (window.innerWidth >= 760) {
        window.__attentive.trigger("null", "null", "null", `${signupID}`);
      } else {
        window.__attentive.trigger("null", "null", "null", `${signupIDMobile}`);
      }
    }
    updateWaitlistButton() {
      const waitlistId = this.activeVariantContent.querySelector('#waitlist-id')?.innerText ?? null;
      const waitlistIdMobile = this.activeVariantContent.querySelector('#waitlist-id-mobile')?.innerText ?? null;
      const isInStock = this.activeVariantContent.querySelector('#in-stock')?.innerText === 'true';
      // check if in stock first
      if (waitlistId && waitlistIdMobile && !isInStock) {
        this.signupButton.disabled = false;
        this.signupButton.classList.remove('hidden');
        this.atcButton.classList.add('hidden');
        this.signupButton.removeEventListener('click', () => this.handleSignupClick(waitlistId, waitlistIdMobile));
        this.signupButton.addEventListener('click', () => this.handleSignupClick(waitlistId, waitlistIdMobile));
      } else {
        this.atcButton.classList.remove('hidden');
        this.signupButton.disabled = true;
        this.signupButton.classList.add('hidden');
      }
    }

    // Group Selector Functions
    handleGroupSelectorVariantSelect(event){
      const variant = event.target.closest('li.vbb-variant-selector__item');
      this.hoverCategory = variant.dataset.category;
      const label = this.querySelector(`.js-variant-label`);
      const labelGroup = this.querySelector(`.vbb-variant-selector__category-item--title[data-category="${this.hoverCategory}"] span`);
      const variantTitle = variant.dataset.variantTitle;
      this.categoryTitles = this.querySelectorAll(`.vbb-variant-selector__category-item--title`)
      this.categoryTitles.forEach((item) => {
        const category = item.getAttribute('data-category');
        // Check if the category matches the specified string
        if (category !== this.hoverCategory) {
          // If the category doesn't match, set data-active to false
          item.querySelector('span').setAttribute('data-active', 'false');
        } else {
          item.querySelector('span').setAttribute('data-active', 'true');
        }
      });
      label.innerText = `${variant.dataset.variantTitle} ${variant.dataset.variantDescription ? ` - ${variant.dataset.variantDescription}` : ''}`
      labelGroup.innerText = `${variant.dataset.variantTitle} ${variant.dataset.variantDescription ? ` - ${variant.dataset.variantDescription}` : ''}`
    }

    handleGroupSelectorVariantHoverOut(event){
      const label = this.querySelector(`.vbb-variant-selector__category-item--title[data-category="${this.activeCategory}"] span`);
      this.categoryTitles.forEach((item) => {
        const category = item.getAttribute('data-category');
        // Check if the category matches the specified string
        if (category !== this.activeCategory) {
          // If the category doesn't match, set data-active to false
          item.querySelector('span').setAttribute('data-active', 'false');
        } else {
          item.querySelector('span').setAttribute('data-active', 'true');
          label.innerText = ` - ${this.activeVariantTitle}`
        }
      });
    }

    connectedCallback() {
      this.variantSelectorItems.forEach(variantSelectorLink => {
        variantSelectorLink.addEventListener('click', event => {
          event.preventDefault();
          this.handleVariantChange(event);
        });
        if(!this.card){
          variantSelectorLink.addEventListener('mouseenter', event => {
            const variant = event.target.closest('li.vbb-variant-selector__item');
            this.hoverCategory = variant.dataset.category;

            if(!this.activeVariantLabel) return;
            const label = this.activeVariantLabel
            label.innerText = `${variant.dataset.variantTitle} ${variant.dataset.variantDescription ? ` - ${variant.dataset.variantDescription}` : ''}`
          });
          variantSelectorLink.addEventListener('mouseleave', event => {
            this.updateActiveVariantLabel()
          });
        }
      });



      // Group Selector
      if (this.dataset.groupSelector === "true") {
        this.variantTabs = this.querySelectorAll("variant-tabs span");
        this.variantSelectorOptions = this.querySelectorAll(
          ".vbb-variant-selector__item"
        );
        if (this.variantTabs.length > 0) {
          this.variantTabs.forEach(tab => {
            tab.addEventListener('click', () => {
              const category = tab.dataset.category;

              this.variantTabs.forEach(allTab => {
                allTab.classList.remove('active')
              })

              tab.classList.add("active");

              this.variantSelectorOptions.forEach(option => {
                if (category == 'all') {
                  option.style.display = 'block'
                } else if (option.dataset.category === category) {
                  option.style.display = 'block'
                } else {
                  option.style.display = 'none'
                }
              })
              const options = document.querySelectorAll('.vbb-variant-selector__category-item--title')
              options.forEach(option => {
                if (option.dataset.category === category) {
                  option.style.display = 'block'
                } else {
                  option.style.display = 'none'
                }})
            })
          })
        }
      }

      if(this.dataset.groupSelector === "true" && !window.isTouch) {
        this.variantSelectorItems.forEach(variantSelectorLink => {
          variantSelectorLink.addEventListener('mouseover', event => {
            this.handleGroupSelectorVariantSelect(event);
          });
        });
        this.variantSelectorItems.forEach(variantSelectorLink => {
          variantSelectorLink.addEventListener('mouseleave', event => {
            this.handleGroupSelectorVariantHoverOut(event);
          });
        });
      } else if (this.dataset.groupSelector === "true" && window.isTouch) {
        this.variantSelectorItems.forEach(variantSelectorLink => {
          variantSelectorLink.addEventListener('click', event => {
            this.handleGroupSelectorVariantSelect(event);
          });
        });
      }

      // Card
      if (this.card && !window.isTouch) {
        this.variantSelectorItems.forEach(variantSelectorLink => {
          variantSelectorLink.addEventListener('mouseover', event => {
            this.handleItemHover(event);
          });
        });
        this.variantSelectorItems.forEach(variantSelectorLink => {
          variantSelectorLink.addEventListener('mouseleave', event => {
            this.handleItemHoverOut(event);
          });
        });
        const cardLink = this.card.querySelector('.card-link')
        cardLink.addEventListener('mouseover', event => {
          const hoverImage = this.querySelector(`.vbb-variant-selector__item a[data-variant-id="${this.productForm.dataset.activeVariant}"]`)
          if(hoverImage.dataset.hoverImage) {

            let newImagesSrc = hoverImage.dataset.hoverImage

            let image = this.card.querySelector('.card__media img');
            clearTimeout(this.hoverOutTimeout);
            if (newImagesSrc) {
              image.srcset = newImagesSrc;
            }
          }
        })
        cardLink.addEventListener('mouseleave', event => {
          const hoverImage = this.querySelector(`.vbb-variant-selector__item a[data-variant-id="${this.productForm.dataset.activeVariant}"]`)
          let newImagesSrc = hoverImage.dataset.mainImage

          let image = this.card.querySelector('.card__media img');
          clearTimeout(this.hoverOutTimeout);
          if (newImagesSrc) {
            image.srcset = newImagesSrc;
          }
        })
      }
      if (this.card && window.isTouch) {
        this.card.querySelectorAll('a[data-main-image]').forEach(item => {
          item.addEventListener('click', (e) => {
            const hoverImage = e.currentTarget.dataset.mainImage
            if(hoverImage) {
              let newImagesSrc = hoverImage
              let image = this.card.querySelector('.card__media img');
              clearTimeout(this.hoverOutTimeout);
              if (newImagesSrc) {
                image.srcset = newImagesSrc;
              }
            }
          })
        })
      }
      if (this.sharpenerCheckbox) {
        this.sharpenerCheckbox.querySelector('input').style.pointerEvents = 'none';
        this.mappedSharpenerVariantIds = JSON.parse(this.querySelector('[type="application/json"]').textContent);

        this.sharpenerCheckbox.querySelector('a').addEventListener('click', event => {
          event.preventDefault();
          this.handleVariantChange(event, true);
        });
      }

      if (this.shouldUpdateHistoryState) {
        window.addEventListener('popstate', this.handleVariantChange.bind(this));
        window.history.replaceState({variantId: this.activeVariantId}, null, window.location.href);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.handleVariantChange.bind(this));
    }
  });
}
